import {
  CounselorsOrdering,
  ICounselorsFilterPresentation,
  ProductFeedbackPortable,
} from "@3gaam/api/types/consultancy";
import { ComplexPackageCounselorFieldOption } from "@3gaam/api/types/store";
import { create } from "zustand";
import { immer as immerMiddleware } from "zustand/middleware/immer";

export type ModalsType = {
  rating: {
    productFeedback: ProductFeedbackPortable;
  };
  ordering: {
    onItemClick: (item: CounselorsOrdering) => void;
  };
  filtering: {};
  customPopup: {
    rawItems:
      | ICounselorsFilterPresentation[]
      | ComplexPackageCounselorFieldOption[];
    title: string | null | undefined;
    onItemClick?: (
      item: ICounselorsFilterPresentation | ComplexPackageCounselorFieldOption,
    ) => void;
  };
  categories: {};
  custom: {};
};

type Modal = {
  name: keyof ModalsType;
  payload: ModalsType[keyof ModalsType];
};

interface State {
  activeModal: Modal | undefined;

  openModal: (modal: Modal) => void;
  closeModal: () => void;
  getActiveModal: (
    name: keyof ModalsType,
  ) => ModalsType[keyof ModalsType] | undefined;
}

export const useModal = create<State>()(
  immerMiddleware((set, get) => ({
    activeModal: undefined,
    openModal: (modal) => {
      set((state) => {
        state.activeModal = modal;
      });
    },
    closeModal: () => {
      set((state) => {
        state.activeModal = undefined;
      });
    },
    getActiveModal: (name: keyof ModalsType) => {
      let activeModal = get().activeModal;
      if (activeModal && activeModal.name === name) {
        return activeModal.payload;
      }
      return undefined;
    },
  })),
);
